import { styled } from '@mui/material';

import List from '../../components/List';

export const StyledList = styled(List)(({ theme }) => ({
  gap: theme.spacing(3),
}));
